<template>
    <div class="TemplateTab ">
        <!-- <div class="UploadMedia d-flex align-items-center p-3">
            <a href="javascript:;" class="border bg-light searchIcon mr-3"><i class="fas fa-search"></i></a>
            <div class="d-flex justify-content-between align-items-center uploadArea border bg-light flex-grow-1 px-3">
                <div>Upload Media</div>
                <i class="fas fa-upload"></i>
            </div>
        </div> -->
        <!-- <div class="imagsGallery p-3 ">
            <h5 class="text-muted py-2">Media</h5>
        </div> -->

        <div role="tablist" aria-orientation="horizontal" class="d-flex tabshere justify-content-evenly border-bottom border-gray-300"
            >
            <span aria-controls="tabs--panel--0" @click="switchTabs(1)" :class="`${activeTab === 1 ? 'active' : ''} p-2`" aria-selected="true" role="tab" tabindex="0"
                 id="tabs--tab--0" type="button"
                data-selected="">Photos</span>
                <span aria-controls="tabs--panel--1" @click="switchTabs(2)" aria-selected="false" role="tab"
                tabindex="-1" data-reach-tab="" :class="`${activeTab === 2 ? 'active' : ''} p-2`" id="tabs--tab--1"
                type="button">Gifs</span>
                <span aria-controls="tabs--panel--2" aria-selected="false" role="tab"
                tabindex="-1" data-reach-tab="" @click="switchTabs(3)" :class="` ${activeTab === 3 ? 'active' : ''} p-2`" id="tabs--tab--2"
                type="button">Videos</span>
        </div>
        <div class="py-3 tabDetails">
            <PhotosTab v-if="activeTab === 1" />
            <GiphyTab v-else-if="activeTab === 2" />
            <PexelsTab v-else-if="activeTab === 3" />
        </div>
    </div>
</template>

<script>
 import PhotosTab from "../SidebarPanelTabs/Photos.vue"
 import GiphyTab from "../SidebarPanelTabs/Giphy.vue"
 import PexelsTab from "../SidebarPanelTabs/Pexel.vue"
export default {
    name: "MediaTab",
    data(){
        return {
            activeTab:1
        }
    },
    components:{
        PhotosTab,
        GiphyTab,
        PexelsTab
    },
    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
    },
    methods: {
        switchTabs(index){
            this.activeTab = index
        }
    }
}
</script>
<style scoped>
.h-45px {
    height: 45px;
}

.imagsGallery h5 {
    letter-spacing: .1em;
    font-size: 15px;

}

.imagsGallery {
    background-color: rgb(248 249 250);
}

.justify-content-evenly{
    justify-content: space-evenly;
}



.searchIcon {
    line-height: 1px;
    height: 43px;
    width: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    color: #474747;
    text-decoration: none;
}

.uploadArea {
    height: 43px;
    width: 43px;
    border-radius: 5px;

}
.tabshere .active{
    border-bottom: 4px solid #8e42ff;
}
</style>